<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon (nzBack)="onBack()" nzTitle="Usuário" nzSubtitle=" - Lançamento de usuários.">
    </nz-page-header>

    <form nz-form [formGroup]="usuarioForm" autocomplete="off" (ngSubmit)="onSubmitUsuario()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired>Nome:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="name" maxlength="100" formControlName="name" placeholder="Nome" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired>E-mail:</nz-form-label>

                    <nz-form-control nzHasFeedback [nzErrorTip]="errorTpl">
                        <input name="email" formControlName="email" readonly onfocus="this.removeAttribute('readonly');" onBlur="this.setAttribute('readonly', true);" autocomplete="off" nz-input placeholder="exemplo@exemplo.com" />
                        <ng-template #errorTpl let-control>
                            <ng-container *ngIf="control.hasError('email')">
                                E-mail inválido!
                            </ng-container>
                            <ng-container *ngIf="control.hasError('required')">
                                Esse campo é obrigatório!
                            </ng-container>
                            <ng-container *ngIf="control.hasError('duplicated')">
                                O email já esta em uso!
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="10">
                <nz-form-item>
                    <nz-form-label nzRequired>Tipo de Usuário:</nz-form-label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <nz-select #tipoTpl (ngModelChange)="changeTipo($event)" name="tipo" formControlName="tipo" nzShowSearch nzPlaceHolder="Seleciona o Tipo">
                            <nz-option [nzLabel]="'Administrador'" [nzValue]="'ADMINISTRADOR'">
                            </nz-option>
                            <nz-option [nzLabel]="'Parceiro'" [nzValue]="'PARCEIRO'">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="7">
                <nz-form-item>
                    <nz-form-label [nzRequired]="!id && tipoTpl?.activatedValue === 'ADMINISTRADOR'">Senha:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input name="password" type="password" autocomplete="off" formControlName="password" nz-input placeholder="******" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="7">
                <nz-form-item>
                    <nz-form-label [nzRequired]="!id && tipoTpl?.activatedValue === 'ADMINISTRADOR'">Confirmar Senha:</nz-form-label>

                    <nz-form-control nzHasFeedback [nzErrorTip]="errorPassword">
                        <input name="confirmar_password" type="password" formControlName="confirmar_password" nz-input placeholder="******" />
                        <ng-template #errorPassword let-control>
                            <ng-container *ngIf="control.hasError('required')">
                                Confirme sua senha!
                            </ng-container>
                            <ng-container *ngIf="control.hasError('confirm')">
                                Senha inválida!
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>


            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="id" nzBlock>Atualizar</button>
                <button nz-button *ngIf="!id" nzType="primary" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>